export default __webpack_public_path__ + "static/media/weather-details2.1c4c74dc.svg";